import { DOCUMENT } from '@angular/common';
import { Injectable, Inject } from '@angular/core';

import { ReplaySubject, Observable, first } from 'rxjs';

import { AppConfigService } from '../../minimal/services/AppConfig';
import { AuthInfoService } from '../../minimal/services/AuthInfo';
import { SystemAlertSnackBarService } from '../../shared/components/system-alert-snackbar';

@Injectable()
export class RevHeroService {
  // support loading multiple scripts if necessary in the future
  _loadedLibraries: { [url: string]: ReplaySubject<void> } = {};

  private readonly _REV_HERO_SCRIPT_URL = 'https://assets.revenuehero.io/scheduler.min.js';
  private readonly _REV_HERO_ROUTER_ID = this._appConfig.getValue('revHeroRouterId');
  private readonly _HUBSPOT_FORM_ID = 'hsForm_1959317e-9d5f-4c08-8886-c6c3b667dc7e';

  constructor(
    @Inject(DOCUMENT) private readonly _document: any,
    private _appConfig: AppConfigService,
    private _authInfo: AuthInfoService,
    private _snackBar: SystemAlertSnackBarService,
  ) {}

  loadScript(url: string): Observable<any> {
    if (this._loadedLibraries[url]) {
      return this._loadedLibraries[url].asObservable();
    }

    this._loadedLibraries[url] = new ReplaySubject();

    const script = this._document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.onload = () => {
      this._loadedLibraries[url].next();
      this._loadedLibraries[url].complete();
    };

    this._document.body.appendChild(script);

    return this._loadedLibraries[url].asObservable();
  }

  openUpgradeRequestModal() {
    this.loadScript(this._REV_HERO_SCRIPT_URL)
      .pipe(first())
      .subscribe(() => {
        const person = this._authInfo.authPerson;
        const firstName = person.firstName;
        const lastName = person.lastName;
        const email = person.email;

        // @ts-ignore - RevenueHero is loaded dynamically from the above service call
        const hero = new RevenueHero({
          routerId: this._REV_HERO_ROUTER_ID,
          showLoader: true,
          requireConfirmation: true,
        });
        hero.schedule(this._HUBSPOT_FORM_ID);

        hero
          .submit({
            firstname: firstName,
            lastname: lastName,
            email: email,
          })
          .then(data => {
            hero.dialog.open(data);
          })
          .catch(error => {
            this._snackBar.error('An error occurred. Please try again later.');
            console.log(error);
          });
      });
  }
}

/* Usage */
/*
this._revHeroService.loadScript('https://scriptUrl.js').subscribe(() => {
   // run when loaded
});
*/
